// 国际化过滤器
import { showToast } from 'vant'
import { addrStoreInfo } from '@/stores'
import AjaxAuthService from '@/api/auth'
import { lang as coreLang } from '@core/langs'

export const lang = coreLang
export const sendParams = () => ({
  /**寄件人 */
  sender: '',
  /**寄件人收件所在区 */
  senderArea: '',
  /**寄件人收件所在区编码 */
  senderAreaId: '',
  /**寄件人寄件所在市 */
  senderCity: '',
  /**寄件人寄件所在市编码 */
  senderCityId: '',
  /**寄件人详细地址 */
  senderDetailAddr: '',
  /**寄件人手机 */
  senderPhone: '',
  /**邮箱 */
  email: '',
  /**寄件人寄件所在省 */
  senderProvince: '',
  /**寄件人寄件所在省编码 */
  senderProvinceId: '',
  /** 始发区域ID*/
  startPointId: '',
  stationCode: ''
})
export const reciptParams = () => ({
  /**收件人 */
  recipient: '',
  /**收件人收件所在区 */
  recipientArea: '',
  /**收件人收件所在区编码 */
  recipientAreaId: '',
  /**收件人收件所在市 */
  recipientCity: '',
  /**收件人收件所在市编码 */
  recipientCityId: '',
  /**收件人详细地址 */
  recipientDetailAddr: '',
  /**收件人手机 */
  recipientPhone: '',
  /**收件人收件所在省 */
  recipientProvince: '',
  /**收件人收件所在省编码 */
  recipientProvinceId: ''
})

export const goodsInfo = () => ({
  /**袋子规格 */
  bagType: 'NONE',
  /**快递公司 */
  express: 'JT_EXPRESS',
  /**快递公司ID */
  expressId: '',
  /**快递公司编码 */
  expressCode: '',
  /**快递公司名称 */
  expressName: '',
  /**快递公司图标 */
  expressPhoto: '',
  /**物品类型 */
  goodsType: 'LIFE',
  /**保价费 */
  quoteFee: '',
  /**数量 */
  qty: 1,
  /**重量 */
  weight: 1,
  /**物品类别 */
  kindType: 'PARCEL',
  /**物品价值 */
  itemValue: '',
  /**快件类型 */
  fastParcelType: 'EZ',
  /**总费用 */
  totalCharge: '--',
  /**运费 */
  transportCharge: '',
  /**目的区域ID */
  terminalPointId: '',
  /**优惠金额 */
  couponsFee: '',
  /**siper服务费 */
  superFee: ''
})
export const formatter = (value: string) => {
  const reg =
    /[~!@#$%^&*()_+|}{":?><,./;'[\]\=` 、￥…！（）》《？“：’；”‘【】]|(null)|(NULL)/g
  // if (reg.test(value)) {
  // showToast(lang('不能填写特殊字符') + ' ~!@#$%^&* \\()_+|}{":?><,./;=]`、[')
  // }
  return value.replace(reg, '')
}
/**验证手机号 */
export const formatterMobile = (val: any) => {
  const reg = /^\d{10}$/
  if (val && !reg.test(val)) {
    showToast(lang('请输入10位手机号'))
  }
}
// 定义一个正则表达式来匹配电子邮件地址的格式
export const validateEmail = (email: any) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (email && !regex.test(email)) {
    showToast(lang('请输入邮箱'))
    return false
  }
  return true
}
/**验证袋子规格 */
export const validateBagType = (formState: any): boolean => {
  const { weight, bagType, fastParcelType } = formState
  if (fastParcelType === 'EZ' && bagType && bagType !== 'NONE' && weight) {
    if (bagType === 'SMALL' && weight > 3) {
      showToast(lang('当前选择Small包裹,重量应在3kg以下'))
      return false
    }
    if (bagType === 'MEDIUM' && weight > 5) {
      showToast(lang('当前选择Medium包裹,重量应在5kg以下'))
      return false
    }
    if (bagType === 'BIG' && weight > 8) {
      showToast(lang('当前选择Large包裹,重量应在8kg以下'))
      return false
    }
  }
  if (fastParcelType === 'SP' && weight && weight > 5) {
    showToast(lang('super件重量不能超过5kg'))
    return false
  }
  return true
}
/**物品类型 */
export const goodsList = [
  { name: lang('生活用品'), value: 'LIFE' },
  { name: lang('文件'), value: 'DOCUMENT' },
  { name: lang('数码产品'), value: 'DIGITAL_PRODUCTS' },
  { name: lang('食品'), value: 'FOOD' },
  { name: lang('服装'), value: 'COSTUME' },
  { name: lang('其他'), value: 'OTHER' }
]
/**袋子规格 */
export const bagList = [
  { name: 'No Package', value: 'NONE' },
  { name: 'Small (<=3KG)', value: 'SMALL' },
  { name: 'Medium (<=5KG)', value: 'MEDIUM' },
  { name: 'Large (<=8KG)', value: 'BIG' }
]
/**袋子规格 */
export const kindType = [
  { name: 'PARCEL', value: 'PARCEL' },
  { name: 'ELECTRONIC', value: 'ELECTRONIC' },
  { name: 'DOCUMENT', value: 'DOCUMENT' }
]
/**快件类型 */
// export const fastParcelTypeList = [
//   { name: 'EZ', value: 'EZ' },
// { name: 'BP', value: 'BP' },
// ]
/**获取需要监听的字段，监听这些字段进行保价费计算 */
export const watchFiled = async (obj?: any) => {
  const _store = addrStoreInfo()
  const {
    bagType,
    express,
    expressId,
    fastParcelType,
    itemValue,
    kindType,
    weight
  } = obj ? obj : _store.getGoodsInfo
  const { senderCityId, senderProvinceId, stationCode, senderPhone } =
    _store.getSenderInfo
  const { recipientCityId, recipientProvinceId, recipientPhone } =
    _store.getReciptInfo
  if (isNaN(Number(weight))) {
    return
  }
  const flag = [
    bagType,
    express,
    expressId,
    fastParcelType,
    itemValue,
    kindType,
    weight,
    senderPhone,
    senderCityId,
    senderProvinceId,
    recipientPhone,
    recipientCityId,
    recipientProvinceId,
    _store.getIsNewUser
  ].every((item) => {
    return item
  })
  const expObj = {
    quoteFee: '',
    totalCharge: '--',
    transportCharge: '',
    terminalPointId: '',
    couponsFee: '',
    superFee: ''
  } as any
  if (!flag) {
    _store.insertSenderInfo({ startPointId: '' })
    return expObj
  }
  const res = await AjaxAuthService.orderData({
    bagType,
    express,
    expressId,
    fastParcelType,
    itemValue,
    kindType,
    weight: Number(weight),
    senderPhone,
    senderCityId,
    senderProvinceId,
    recipientCityId,
    stationCode,
    recipientProvinceId,
    couponsType: _store.getIsNewUser === 'YES' ? 'FIRST_ORDER' : 'COUPONS_NONE'
  })
  if (res.code === 1) {
    _store.insertSenderInfo({ startPointId: res.data.startPointId })
    expObj.quoteFee = res.data.insuredFee
    expObj.totalCharge = res.data.totalCharge
    expObj.transportCharge = res.data.freight
    expObj.terminalPointId = res.data.terminalPointId
    expObj.couponsFee = res.data?.couponsFee ? res.data?.couponsFee : 'null'
    expObj.superFee = res.data?.superFee ? res.data?.superFee : ''
    _store.setIsZeroCost(
      res.data?.couponsTypeEnum && res.data.couponsTypeEnum.id === 'FIRST_ORDER'
        ? true
        : false
    )
  } else {
    _store.insertSenderInfo({ startPointId: '' })
    return expObj
  }
  return expObj
}
/**格式化千分位 */
export function formatThousand(value: number | string): string {
  if (!value) return ''
  const numStr = String(value)
  const [integerPart, decimalPart] = numStr.split('.')
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger
}
